export function generateUUID() {
  if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
    return crypto.randomUUID();
  }

  // Fallback UUIDv4 generator
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
}


const STORAGE_KEY = 'witzo_chat_session_token';
const ACTIVE_HANDOFF_SESSION_KEY = 'witzo_chat_active_handoff_session_token';
const HANDOFF_ID_KEY = 'witzo_chat_handoff_id';

function emitActiveHandoffSessionChange(): void {
    if (typeof window === 'undefined') return;
    window.dispatchEvent(new CustomEvent('witzo-active-handoff-session-change'));
}

function getActiveHandoffSessionToken(): string | null {
    return localStorage.getItem(ACTIVE_HANDOFF_SESSION_KEY);
}

function createToken():string{
    const activeHandoffSession = getActiveHandoffSessionToken();
    if (activeHandoffSession) {
        localStorage.setItem(STORAGE_KEY, activeHandoffSession);
        return activeHandoffSession;
    }

    let session = localStorage.getItem(STORAGE_KEY);

    if(!session){
        session = generateUUID();
        localStorage.setItem(STORAGE_KEY, session);
    }

    return session;
}

function resetToken(): string {
    const session = generateUUID();
    localStorage.setItem(STORAGE_KEY, session);
    return session;
}

function storeActiveHandoffSession(sessionId: string, handoffId: string): void {
    localStorage.setItem(ACTIVE_HANDOFF_SESSION_KEY, sessionId);
    localStorage.setItem(HANDOFF_ID_KEY, handoffId);
    localStorage.setItem(STORAGE_KEY, sessionId);
    emitActiveHandoffSessionChange();
}

function storeHandoffId(id: string): void {
    localStorage.setItem(HANDOFF_ID_KEY, id);
    emitActiveHandoffSessionChange();
}

function getStoredHandoffId(): string | null {
    return localStorage.getItem(HANDOFF_ID_KEY);
}

function clearActiveHandoffSession(): void {
    localStorage.removeItem(ACTIVE_HANDOFF_SESSION_KEY);
    localStorage.removeItem(HANDOFF_ID_KEY);
    emitActiveHandoffSessionChange();
}

const clearHandoffId = clearActiveHandoffSession;

export { createToken, clearActiveHandoffSession, clearHandoffId, getActiveHandoffSessionToken, getStoredHandoffId, resetToken, storeActiveHandoffSession, storeHandoffId };

